import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME } from '../constants';
import { apiProvider } from '../api';

const filter = {
	PlannedCallDateFrom: null as Date | null,
	PlannedCallDateTo: null as Date | null,
	Vin: null as string | null,
	RegistrationNumber: null as string | null,
	VehicalModel: null as string | null,
	PhoneNumber: null as string | null,
	Email_Id: null as string | null,
	Activity_Id: null as Number | null,
	SaleDateFrom: null as Date | null,
	SaleDateTo: null as Date | null,
	CustomerName: null as string | null,
	LeadArea: null as Number | null,
	LeadType: null as Number | null,
	ExpectedPurchaseDateFrom: null as Date | null,
	ExpectedPurchaseDateTo: null as Date | null,
	LeadStatus: null as Number | null,
	Remark: null as string | null,
};

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: 'Customer_leads',
	dropdownList: {
		LeadArea: [],
		LeadType: [],
		FollowUpStatus: [],
		LeadStatus: [],
	},
	filter,
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
